import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);

  const token = tokenService.token;

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        'x-transaccion-token': token,
      },
    });

    return next(authReq);
  }

  return next(req);
};
